import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import { MuiThemeProvider } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import {
    SNACK_BAR_SUCCESS_THEME,
    SNACK_BAR_DANGER_THEME,
    SNACK_BAR_FAILURE_THEME
} from '../Snackbar/TSnackbarMuiTheme';

const style = (theme) => ({
    success: {
        color: 'white !important',
        paddingRight: 10
    },
    error: {
        color: 'white !important',
        backgroundColor: 'red !important'
    }
});

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const AlertSnackBar = (props) => {
    const { open, resetSnackBar, variant, message } = props;
    let xTheme;
    if (variant === 'success') {
        xTheme = SNACK_BAR_SUCCESS_THEME;
    } else if (variant === 'error') {
        xTheme = SNACK_BAR_DANGER_THEME;
    } else {
        xTheme = SNACK_BAR_FAILURE_THEME;
    }

    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(open);
        if (open) {
            setTimeout(() => {
                setShow(false);
                resetSnackBar();
            }, 4000);
        }
    }, [open, resetSnackBar]);

    return (
        <MuiThemeProvider theme={xTheme}>
            <Snackbar
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                open={show}
                autoHideDuration={4000}
                onClose={resetSnackBar}
            >
                <Alert onClose={resetSnackBar} severity={variant} id="message-id">
                    {message}
                </Alert>
            </Snackbar>
        </MuiThemeProvider>
    );
};

export default withStyles(style)(AlertSnackBar);
